var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "panel" }, [
      _c(
        "div",
        { staticClass: "panel-section" },
        [
          _c("countdown-timer", {
            attrs: {
              "start-date-string": "2025-05-02T00:00:00-0700",
              "target-date-string": "2025-05-06T09:00:00-0700",
              "header-text":
                "<span style='color: #E39A4D;'>TechX</span> day 1 is in:",
              "footer-text": "Register today!",
              "target-url":
                "https://conferences.autodesk.com/flow/autodesk/techx2025/sessioncatalog/page/digital/session/1743714919617001AQBx"
            }
          }),
          _vm._v(" "),
          _c("countdown-timer", {
            attrs: {
              "start-date-string": "2025-05-06T10:00:00-0700",
              "target-date-string": "2025-05-07T09:00:00-0700",
              "header-text":
                "<span style='color: #E39A4D;'>TechX</span> day 2 is in:",
              "target-url":
                "https://conferences.autodesk.com/flow/autodesk/techx2025/sessioncatalog/page/digital/session/1743714967721001DdQS"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "panel-section" }, [_c("popular-apps")], 1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-section" },
        [_c("my-content", { ref: "myContent" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "panel-section" }, [_c("bookmarks")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "panel-section" }, [_c("events")], 1)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07cbd747", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07cbd747","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/RightPanel.vue
// module id = null
// module chunks = 